import { Link } from "react-router-dom";
import { Lotus, KanthaStitch } from "./Motifs";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/collections", label: "Collections" },
  { to: "/folk-art", label: "Folk Art" },
  { to: "/journal", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

export default function Footer({ content = {} }) {
  return (
    <footer data-testid="site-footer" className="bg-ink text-paper grain relative overflow-hidden">
      <div className="relative z-10 max-w-[1500px] mx-auto px-5 md:px-10 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12 pb-16">
          <div>
            <div className="flex items-center gap-3">
              <Lotus className="w-8 h-8 text-alta" />
              <span className="font-serif text-4xl md:text-5xl tracking-[0.24em] font-light">IPSITA</span>
            </div>
            <p className="mt-4 text-paper/60 text-sm tracking-[0.18em] uppercase">
              Fashion Designer • Bengali Folk Artist
            </p>
            <p className="mt-8 font-bengali text-2xl text-paper/50">সূতো আর কথা — বাংলার গল্প</p>
          </div>

          <div className="flex gap-16 md:gap-24">
            <div>
              <p className="text-[11px] tracking-[0.25em] uppercase text-paper/40 mb-5">Explore</p>
              <ul className="space-y-3">
                {NAV.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="link-underline text-sm text-paper/75 hover:text-paper transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-[11px] tracking-[0.25em] uppercase text-paper/40 mb-5">Connect</p>
              <ul className="space-y-3">
                <li>
                  <a data-testid="footer-instagram" href={content.social_instagram || "#"} target="_blank" rel="noreferrer" className="link-underline text-sm text-paper/75 hover:text-paper transition-colors">
                    Instagram
                  </a>
                </li>
                <li>
                  <a data-testid="footer-pinterest" href={content.social_pinterest || "#"} target="_blank" rel="noreferrer" className="link-underline text-sm text-paper/75 hover:text-paper transition-colors">
                    Pinterest
                  </a>
                </li>
                <li>
                  <a data-testid="footer-email" href={`mailto:${content.social_email || "studio@ipsita.in"}`} className="link-underline text-sm text-paper/75 hover:text-paper transition-colors">
                    Email
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <KanthaStitch className="opacity-30" />

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p data-testid="footer-note" className="font-serif italic text-lg text-paper/70">
            {content.footer_note || "Made with stories, thread and Bengal."}
          </p>
          <p className="text-[11px] tracking-[0.2em] uppercase text-paper/35">
            © {new Date().getFullYear()} Ipsita Studio · Kolkata
          </p>
        </div>
      </div>
    </footer>
  );
}
